module.exports = __webpack_public_path__ + "img/logo.3f86bae9.png";